/**
 * Bloc « réponse directe » pour AEO / AI Overviews / Perplexity.
 * Texte factuel court, citation-friendly.
 */
export default function AnswerBlock({ children, className = "" }) {
    return (
        <p
            className={`max-w-2xl text-base sm:text-lg text-brown-soft leading-relaxed ${className}`}
            data-speakable="true"
        >
            {children}
        </p>
    );
}
